module.exports = __webpack_public_path__ + "static/1352226526.5bebe733.jpg";